import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchForgetPass } from "./forgetPassApi";

export interface ForgetPassState {
  forgetpass: any;
  status: "idle" | "loading" | "failed" | "success";
  verifyotp : string;
}

const initialState: ForgetPassState = {
  forgetpass: [],
  status: "idle",
  verifyotp : '',
};

export const GetForgetPass = createAsyncThunk(
  "fetchForgetPass",
  async (data: any) => {
    const response = await fetchForgetPass(data);
    return response;
  }
);

export const forgetPassSlice = createSlice({
  name: "fetchForgetPass",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetForgetPass.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetForgetPass.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetForgetPass.fulfilled, (state, action) => {
        state.status = "success";
        state.forgetpass = action.payload.otp; 
        localStorage.setItem('otp', JSON.stringify(action.payload.otp));
      });
  },
});

export const {} = forgetPassSlice.actions;

export const selectForgetPass = (state: RootState) => {
  return state.verifyOtp.forgetpass;
};

export default forgetPassSlice.reducer;
